import React, { useEffect, useState } from "react";

import LeaderSpine from "./LeaderSpine";
import { LEADER_SPINE_IDS, SVGDB_LEADER_PORTRAIT } from "./leaderIds";
import imageSiLong from "../../assets/leaders/SiLong.png";
import imageForte from "../../assets/leaders/Forte.png";
import imageGalmieux from "../../assets/leaders/Galmieux.png";
import imageDrache from "../../assets/leaders/Drache.png";
import imageLishenna from "../../assets/leaders/Lishenna.png";
import imageCeridwen from "../../assets/leaders/Ceridwen.png";
import imageKuon from "../../assets/leaders/Kuon.png";
import imageDaria from "../../assets/leaders/Daria.png";
import imageBunny from "../../assets/leaders/Bunny.png";
import imageAlbert from "../../assets/leaders/Albert.png";
import imageSekka from "../../assets/leaders/Sekka.png";
import imageHozumi from "../../assets/leaders/Hozumi.png";
import imageOrchis from "../../assets/leaders/Orchis.png";
import imageCC from "../../assets/leaders/CC.png";
import imageIcy from "../../assets/leaders/Icy.png";
import imageAnisage from "../../assets/leaders/Anisage.png";
import imageMono from "../../assets/leaders/Mono.png";
import imageVania from "../../assets/leaders/Vania.png";
import imageRola from "../../assets/leaders/Rola.png";
import imageJeanne from "../../assets/leaders/Jeanne.png";
import imageManhattenCafe from "../../assets/leaders/ManhattenCafe.png";
import imageMaru from "../../assets/leaders/Maru.png";
import imageRin from "../../assets/leaders/Rin.png";
import imageUzuki from "../../assets/leaders/Uzuki.png";
import imageMio from "../../assets/leaders/Mio.png";
import imageVanguard from "../../assets/leaders/Vanguard.png";

import "../../css/Leader.css";

export default function Leader({
  name,
  active,
  width = 300,
  height = 240,
  side = "mine",
}) {
  let image;
  switch (name) {
    case "Galmieux":
      image = imageGalmieux;
      break;
    case "Forte":
      image = imageForte;
      break;
    case "SiLong":
      image = imageSiLong;
      break;
    case "Drache":
      image = imageDrache;
      break;
    case "Jeanne":
      image = imageJeanne;
      break;
    case "Rola":
      image = imageRola;
      break;
    case "Albert":
      image = imageAlbert;
      break;
    case "Bunny":
      image = imageBunny;
      break;
    case "Daria":
      image = imageDaria;
      break;
    case "Kuon":
      image = imageKuon;
      break;
    case "Lishenna":
      image = imageLishenna;
      break;
    case "Ceridwen":
      image = imageCeridwen;
      break;
    case "Sekka":
      image = imageSekka;
      break;
    case "Hozumi":
      image = imageHozumi;
      break;
    case "Orchis":
      image = imageOrchis;
      break;
    case "CC":
      image = imageCC;
      break;
    case "Icy":
      image = imageIcy;
      break;
    case "Anisage":
      image = imageAnisage;
      break;
    case "Vania":
      image = imageVania;
      break;
    case "Mono":
      image = imageMono;
      break;
    case "Manhatten Cafe":
      image = imageManhattenCafe;
      break;
    case "Maruzensky":
      image = imageMaru;
      break;
    case "Rin":
      image = imageRin;
      break;
    case "Uzuki":
      image = imageUzuki;
      break;
    case "Mio":
      image = imageMio;
      break;
    case "Vanguard":
      image = imageVanguard;
      break;
    case "Piercye":
      image = SVGDB_LEADER_PORTRAIT.Piercye;
      break;
    case "Lumiore":
      image = SVGDB_LEADER_PORTRAIT.Lumiore;
      break;
    case "Amy":
      image = SVGDB_LEADER_PORTRAIT.Amy;
      break;
    case "Pecorine":
      image = SVGDB_LEADER_PORTRAIT.Pecorine;
      break;
    case "Karyl":
      image = SVGDB_LEADER_PORTRAIT.Karyl;
      break;
    default:
      image = imageGalmieux;
  }

  // When this leader has a Spine animation on svgdb, loop it on top of the
  // static portrait and hide the PNG once it's actually on screen. If loading
  // fails (or the leader has no animation), the PNG simply stays.
  const hasSpine = !!LEADER_SPINE_IDS[name];
  const [spineReady, setSpineReady] = useState(false);
  const [spineFailed, setSpineFailed] = useState(false);
  useEffect(() => {
    setSpineReady(false);
    setSpineFailed(false);
  }, [name]);

  return (
    <div className="LeaderStage" style={{ width, height }}>
      <img
        src={image}
        className={`leaderArt ${active ? "" : "leaderArtInactive"}`}
        alt="Leader"
        style={{ opacity: spineReady ? 0 : 1 }}
      />
      {hasSpine && !spineFailed && (
        <div className="leaderSpineLayer">
          <LeaderSpine
            name={name}
            active={active}
            width={width}
            height={height}
            side={side}
            onReady={() => setSpineReady(true)}
            onError={() => setSpineFailed(true)}
          />
        </div>
      )}
    </div>
  );
}
